/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/
import { Pipe, PipeTransform } from '@angular/core';
import { InaxTranslateService } from './translate';
import { Map } from '../../../@inax/common';

@Pipe({ name: 'translate' })
export class InaxTranslatePipe implements PipeTransform {

  constructor(private _translateService: InaxTranslateService) {}

  transform(value: string, ... options: any[]):string {
    return this._translateService.translate(value, options);
  }

}